// extracted by mini-css-extract-plugin
export default {"validationItem":"ValidationSummary_validationItem__RGXPI","icon":"ValidationSummary_icon__AU7Tw","iconWrapper":"ValidationSummary_iconWrapper__IGffG"};